import { motion } from "framer-motion";
import { Reveal, MaskedLines } from "@/components/Reveal";
import { img } from "@/config";

// Reusable inner-page hero with image background + technical grid overlay
export default function PageHero({ eyebrow, titleLines, subtitle, imageKey = "networking", children }) {
  return (
    <section className="relative overflow-hidden pt-36 pb-16 lg:pb-24" data-testid="page-hero">
      <div className="absolute inset-0 -z-10">
        <img src={img(imageKey)} alt="" className="h-full w-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B1120]/80 via-[#0B1120]/90 to-[#0B1120]" />
        <div className="tech-grid absolute inset-0 opacity-60" />
      </div>
      <div className="glow-blue pointer-events-none absolute -left-20 top-10 h-[400px] w-[400px]" />

      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        {eyebrow && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
            <span className="inline-flex items-center gap-2 rounded-full border border-slate-700 bg-white/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-[#60A5FA]">
              <span className="h-1.5 w-1.5 rounded-full bg-[#2563EB]" />
              {eyebrow}
            </span>
          </motion.div>
        )}
        <MaskedLines
          className="mt-6 font-display font-extrabold tracking-tight text-white"
          lineClassName="text-4xl leading-[1.02] sm:text-5xl lg:text-6xl"
          lines={titleLines}
        />
        {subtitle && (
          <Reveal delay={0.4}>
            <p className="mt-6 max-w-2xl text-lg leading-relaxed text-slate-400">{subtitle}</p>
          </Reveal>
        )}
        {children && <Reveal delay={0.5}>{children}</Reveal>}
      </div>
    </section>
  );
}
